import React from "react";

export type GenericCardContentProps = {
  title: string;
  description: string;
};

export const GenericCardContent: React.FC<GenericCardContentProps> = ({
  title,
  description,
}: GenericCardContentProps) => {
  return (
    <div className="generic-card__content-container">
      <h2>{title}</h2>
      <p>{description}</p>
    </div>
  );
};
